import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import * as gtmService from "./Gtm.service"

const ELEMENTS_BOUND_TO_CLICK_LISTENER = []

export const addOnClickEventListeners = (productListElement) => {
    for(let productElem of productListElement.querySelectorAll(".product-list__item")) {
        if(ELEMENTS_BOUND_TO_CLICK_LISTENER.includes(productElem)) continue;
        
        const gtmProductElem = productElem.querySelector("json-data#gtm-product");
        if(!gtmProductElem) continue;

        const gtmProduct = JSON.parse(gtmProductElem.innerText);
        if(!gtmProduct) continue;

        const productUrlElem = productElem.querySelector("[itemprop='url']");
        if(!productUrlElem) continue;
        const productUrl = productUrlElem.href;

        const list = productElem.querySelector("[itemtype='http://schema.org/Product']").dataset["list"];

        for(let anchorElem of productElem.querySelectorAll("[itemprop='url']")) {
            anchorElem.addEventListener("click", (e) => {
                e.preventDefault();

                const clickObject = {
                    products: [gtmProduct]
                }

                if(list) {
                    clickObject["actionField"] = { list }
                }

                try{
                    gtmService.pushEcommerce({
                        event: 'productClick',
                        ecommerce: {
                            currencyCode: gtmService.getCurrency(),
                            click: clickObject,
                        },
                        eventCallback: () => {
                            if(productUrl) {
                                window.location = productUrl
                            }
                        },
                        eventTimeout: 100
                    });
                }catch(e){
                    console.log("error", e);
                }
            });
        }

        ELEMENTS_BOUND_TO_CLICK_LISTENER.push(productElem);
    }
}